export default function ShieldKeyIcon() {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M18.7666 3.51631L9.59996 6.94965C7.84996 7.61631 6.41663 9.68298 6.41663 11.5663V25.0663C6.41663 26.4163 7.29996 28.1996 8.38329 28.9996L17.55 35.8496C19.1666 37.0663 21.8166 37.0663 23.4333 35.8496L32.6 28.9996C33.6833 28.183 34.5666 26.4163 34.5666 25.0663V11.5663C34.5666 9.69965 33.1333 7.61631 31.3833 6.96631L22.2166 3.53298C21.2833 3.16631 19.7166 3.16631 18.7666 3.51631Z"
        fill="#4F55FD"
      />
      <path
        d="M24.6667 17.5007C24.6667 15.2007 22.8 13.334 20.5 13.334C18.2 13.334 16.3334 15.2007 16.3334 17.5007C16.3334 19.3673 17.5667 20.9173 19.25 21.4507V25.834C19.25 26.5173 19.8167 27.084 20.5 27.084C21.1834 27.084 21.75 26.5173 21.75 25.834V21.4507C23.4334 20.9173 24.6667 19.3673 24.6667 17.5007Z"
        fill="#4F55FD"
      />
    </svg>
  );
}
